module.exports = __webpack_public_path__ + "static/img/c5.2543e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/c5.png
// module id = a/P/
// module chunks = 0